import debounce from 'lodash-es/debounce';
import Flickity from 'flickity';

let mainCarousel = null;
let navCarousel = null;
let bottomCarousel = null;

const initCarousels = () => {
  // Initialize main carousel
  if (!mainCarousel) {
    const mainElement = document.querySelector('[data-carousel-timeline]');
    if (mainElement) {
      mainCarousel = new Flickity(mainElement, {
        imagesLoaded: true,
        cellAlign: 'left',
        contain: false,
        draggable: true,
        dragThreshold: 10,
        pageDots: false,
      });
    }
  }

  // Initialize nav carousel
  if (!navCarousel) {
    const navElement = document.querySelector('[data-carousel-timeline-nav]');
    if (navElement) {
      const navConfig =
        window.innerWidth > 767
          ? {
              asNavFor: '[data-carousel-timeline]',
              cellAlign: 'left',
              contain: true,
              draggable: true,
              dragThreshold: 10,
              prevNextButtons: false,
              pageDots: false,
            }
          : {
              asNavFor: '[data-carousel-timeline]',
              cellAlign: 'center',
              contain: false,
              draggable: true,
              dragThreshold: 10,
              prevNextButtons: false,
              pageDots: false,
            };
      navCarousel = new Flickity(navElement, navConfig);
    }
  }

  // Initialize bottom carousel
  if (!bottomCarousel) {
    const bottomElement = document.querySelector('[data-carousel-timeline-bottom]');
    if (bottomElement) {
      bottomCarousel = new Flickity(bottomElement, {
        asNavFor: '[data-carousel-timeline]',
        cellAlign: 'left',
        contain: false,
        draggable: false,
        prevNextButtons: false,
        pageDots: false,
      });
    }
  }
};

const handleResize = debounce(() => {
  // Re-initialize carousels on resize
  if (mainCarousel) {
    mainCarousel.resize();
  }
  if (navCarousel) {
    navCarousel.resize();
  }
  if (bottomCarousel) {
    bottomCarousel.resize();
  }
}, 500);

export default function () {
  // Check if any carousel elements exist
  const mainElement = document.querySelector('[data-carousel-timeline]');
  const navElement = document.querySelector('[data-carousel-timeline-nav]');
  const bottomElement = document.querySelector('[data-carousel-timeline-bottom]');

  if (!mainElement && !navElement && !bottomElement) {
    return;
  }

  // Initialize carousels when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    initCarousels();
  });

  // Resize event listener
  window.addEventListener('resize', handleResize);
}
